<template>
    <img v-if="url" :src="url">
</template>
<script>
import featuredImage from '@/mixins/featuredImage'

export default {
  props: [
    'mediaId'
  ],
  data () {
    return {
      thumbSize: 480
    }
  },
  mixins: [featuredImage]
}
</script>

<style scoped lang="scss">
  .img-container {
    width: 100%;
    height: 300px;
    background-position: center center;
    background-size: cover;
    border-radius: 6px;
    margin: 50px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/FeaturedImage.vue